var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHeart(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.13185 12.1129L12.0061 19.8049L19.8803 12.1129C21.7913 10.0349 21.3713 6.92572 19.7118 5.14138C18.9031 4.27191 17.8526 3.78295 16.7078 3.87051C15.5591 3.95837 14.1495 4.64023 12.6679 6.45179C12.5056 6.65035 12.2626 6.76552 12.0061 6.76552C11.7496 6.76552 11.5066 6.65035 11.3442 6.45179C9.86284 4.64038 8.45086 3.95578 7.29865 3.86574C6.15041 3.77602 5.09739 4.26318 4.28772 5.1302C2.6275 6.90805 2.20396 10.0168 4.13185 12.1129ZM12.0061 4.61962C10.5202 3.06654 8.956 2.28004 7.43187 2.16094C5.67554 2.0237 4.13679 2.7864 3.03794 3.9631C0.885077 6.26848 0.222692 10.412 2.89173 13.2905C2.90131 13.3008 2.91115 13.3109 2.92123 13.3207L11.4086 21.6117C11.7408 21.9362 12.2713 21.9362 12.6035 21.6117L21.091 13.3207C21.101 13.3109 21.1109 13.3008 21.1205 13.2905C23.7756 10.427 23.1097 6.28392 20.9639 3.9768C19.8679 2.79839 18.3323 2.03127 16.5774 2.16549C15.0545 2.28197 13.4915 3.06704 12.0061 4.61962Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeart);
export default __webpack_public_path__ + "static/media/heart.1c647c597128db36f46264ee2052f6ed.svg";
export { ForwardRef as ReactComponent };